import { FC } from 'react';

import { BackButton } from '@dynamika-shared/ui/BackButton/BackButton';
import { d7Format } from '@dynamika-shared/utils/date';

interface SubjectDetailHeaderProps {
  patientCode: string;
  dob?: string;
  siteLabel: string;
  cohortId?: string;
  onBack: () => void;
}

const DOB_FORMAT = 'MMM-yyyy';

const formatDateOfBirth = (dob?: string): string => {
  if (!dob) {
    return '-';
  }

  const formatted = d7Format(dob, DOB_FORMAT);

  return formatted || dob;
};

export const SubjectDetailHeader: FC<SubjectDetailHeaderProps> = ({
  patientCode,
  dob,
  siteLabel,
  cohortId,
  onBack,
}) => {
  const formattedDob = formatDateOfBirth(dob);

  return (
    <div className='flex items-center justify-between pb-2 pt-3'>
      <div className='flex items-center gap-2'>
        <BackButton action={onBack} />
        <h1 className='text-6xl font-medium'>{patientCode}</h1>
      </div>
      <div className='flex items-center gap-6 text-1624'>
        <div>
          <span className='text-spanishGray'>Date of Birth: </span>
          <span className='font-medium'>{formattedDob}</span>
        </div>
        <div>
          <span className='text-spanishGray'>Site: </span>
          <span className='font-medium'>{siteLabel}</span>
        </div>
        <div>
          <span className='text-spanishGray'>Cohort: </span>
          <span className='font-medium'>{cohortId || '-'}</span>
        </div>
      </div>
    </div>
  );
};
